/**
 * Страница менеджера: список проектов пользователя (manager/userprojects).
 *
 * Маркер инициализации — наличие .delete-project__adm.
 * Конфиг — window.managerUserProjectsConfig (removeBaseUrl).
 *
 * Функционал — подтверждение удаления проекта через showAdmConfirmation + redirect.
 */

function init() {
    if (!document.querySelector('.delete-project__adm')) return;

    const config = window.managerUserProjectsConfig;
    if (!config) {
        console.error('[manager-user-projects] window.managerUserProjectsConfig not found');
        return;
    }

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[manager-user-projects] jQuery not loaded');
        return;
    }
    const showAdmConfirmation = window.showAdmConfirmation;

    $(() => {
        $('.delete-project__adm').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const projectId = $(this).data('id');
            const $row = $(this).closest('tr');
            const projectName = $row.find('td:first').text().trim();

            if (typeof showAdmConfirmation !== 'function') return;

            showAdmConfirmation('Are you sure you want to delete project "' + projectName + '"?', {
                confirmText: 'Delete',
                cancelText: 'Cancel',
            }).then(function (confirmed) {
                if (confirmed) {
                    window.location.href = config.removeBaseUrl + '/' + projectId;
                }
            });
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
